import axios from 'axios'

const client = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  json: true,
})

export default {
  async execute(method, resource, data) {
    return client({
      method,
      url: resource,
      data,
      withCredentials: 'include',
    }).then(req => {
      return req.data
    })
  },

  getCandidate(email) {
    return this.execute('get', `/candidate/${email}`)
  },

  postCandidate(candidate) {
    return this.execute('post', '/candidate/', candidate)
  },

  getTest(id, email) {
    return this.execute('get', `/test/${id}/${email}?action=get_test_by_id`)
  },

  // getAllTests() {
  //   return this.execute('get', `/test/?action=get_all_tests`)
  // },

  // postTest(test) {
  //   return this.execute('get', '/test/', test)
  // },

  submitAnswer(testId, userId, answer) {
    return this.execute('post', `/answer/${testId}/${userId}`, answer)
  },

  markForReview(testID, userId, answer) {
    return this.execute(
      'post',
      `/answer/${testID}/${userId}?action=markForReview`,
      answer
    )
  },

  markForReviewUnanswered(testID, userId, answer) {
    return this.execute(
      'post',
      `/answer/${testID}/${userId}?action=markForReviewUnanswered`,
      answer
    )
  },

  deleteAnswer(testId, userId, answer) {
    return this.execute('delete', `/answer/${testId}/${userId}`, answer)
  },

  getPracticeTestQuestions(test_id, user_id) {
    return this.execute(
      'get',
      `/test/${test_id}/${user_id}?action=get_practice_test_questions`
    )
  },

  postTestee(testId, userId) {
    return this.execute(
      'post',
      `/testee/${testId}/${userId}?action=post_testee`
    )
  },

  startPracticeTest(testId, userId) {
    return this.execute(
      'post',
      `/testee/${testId}/${userId}?action=post_practice_test`
    )
  },

  getTestee(testId, emailId) {
    return this.execute('get', `/testee/details/${testId}/${emailId}`)
  },

  postFeedback(testID, userId, feedback) {
    return this.execute(
      'post',
      `/testee/${testID}/${userId}?action=post_feedback`,
      feedback
    )
  },

  postEndTime(testID, userId) {
    return this.execute(
      'post',
      `/testee/${testID}/${userId}?action=post_endTime`
    )
  },

  postCandidatePhoto(testId, email, details) {
    return this.execute(
      'post',
      `/testee/${testId}/${email}?action=post_candidate_photo`,
      details
    )
  },

  postPing(testId, userId, restartCount) {
    return this.execute(
      'post',
      `/ping/${testId}/${userId}?test_restart_count=${restartCount}`
    )
  },

  sendInviteEmail(testId, data, headers) {
    return this.execute('post', `/email/${testId}`, data, headers)
  },
  sendSummaryEmail(testID) {
    return this.execute('post', `/email/${testID}?action=send_summary_mail`)
  },

  postTestSampleTestCases(testID, userId, questionId, code) {
    return this.execute(
      'post',
      `/submission/${testID}/${userId}/${questionId}?action=2`,
      code
    )
  },

  postRunCustomInput(testID, userId, questionId, code) {
    return this.execute(
      'post',
      `/submission/${testID}/${userId}/${questionId}?action=3`,
      code
    )
  },

  postTestAllTestcases(testID, userId, questionId, code) {
    return this.execute(
      'post',
      `/submission/${testID}/${userId}/${questionId}?action=1`,
      code
    )
  },

  compileUserSubmission(testID, userId, questionId, code) {
    return this.execute(
      'post',
      `/submission/${testID}/${userId}/${questionId}?action=1&fid=-1&tc=-1&sid=-1`,
      code
    )
  },

  executeTestCase(
    testID,
    userId,
    questionId,
    folderId,
    testCaseId,
    submissionId,
    questionConfig
  ) {
    return this.execute(
      'post',
      `/submission/${testID}/${userId}/${questionId}?action=1&fid=${folderId}&tc=${testCaseId}&sid=${submissionId}`,
      questionConfig
    )
  },

  getExecutionResult(testId, userId, questionId) {
    return this.execute('get', `/execution/${testId}/${userId}/${questionId}`)
  },

  getCode(testId, userId, questionId, fileName) {
    return this.execute(
      'get',
      `/code/${testId}/${userId}/${questionId}/file/${fileName}`
    )
  },

  postCode(testId, userId, questionId, code, language_type) {
    return this.execute(
      'post',
      `/code/${testId}/${userId}/${questionId}/${language_type}`,
      code
    )
  },

  getSummaryReport(testID) {
    return this.execute('get', `/summary/${testID}`)
  },

  getPresignedUrl(testId, encodedEmail) {
    return this.execute('get', `/proctoring/get_url/${testId}/${encodedEmail}`)
  },

  postProctoringEvent(testID, userID, eventType) {
    return this.execute(
      'post',
      `/proctoring/record_event/${testID}/${userID}?event=${eventType}`
    )
  },

  checkObjectExists(companyID, encodedEmail) {
    return this.execute(
      'get',
      `/proctoring/check_exists/${companyID}/${encodedEmail}`
    )
  },
}
